import Instagram from "../../assets/icons/instagram.png";
import GitHub from "../../assets/icons/github.png";
import LinkedIn from "../../assets/icons/linkedin.png";
import Email from "../../assets/icons/email.png";
export const SocialData = [
	{
		platform: "Instagram",
		link: "https://www.instagram.com/_m.hirai/",
		icon: Instagram
	},
	{
		platform: "GitHub",
		link: "https://github.com/matthewhirai",
		icon: GitHub
	},
	{
		platform: "LinkedIn",
		link: "https://www.linkedin.com/in/matthew-hirai/",
		icon: LinkedIn
	},
	{
		platform: "mail",
		link: "mailto:mhirai301@gmail.com",
		icon: Email
	}
];
